import './ApiRequests.scss';
import { CHANGE_EVENT_PREFERENCES } from '@sonar-software/sonar-ts-constants';
import { InfoCircleOutlined } from '@ant-design/icons';
import { SonarText } from '@ui/text';
import { Progress, Tooltip } from 'antd';
import React from 'react';
export const ApiRequests = ({ header, maxCalls, usedCalls, tooltip }) => React.createElement("div", { className: 'api-requests' },
    React.createElement(SonarText, { className: 'api-header' },
        header,
        React.createElement(Tooltip, { title: tooltip },
            React.createElement(InfoCircleOutlined, null))),
    React.createElement("div", { className: 'api-data' },
        React.createElement(SonarText, { className: 'used-calls', size: 20, weight: 'semibold' }, usedCalls.toLocaleString('en')),
        ' ',
        React.createElement(SonarText, { className: 'max-calls' }, CHANGE_EVENT_PREFERENCES.OUT_OF(maxCalls))),
    React.createElement(Progress, { className: 'api-progress', percent: Math.round((usedCalls / maxCalls) * 100), size: 'small' }));
